import { Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { action, API, controller } from "../../api/api";
import { ToFormData, useFormatPrice } from "../../hooks/Method";
import DonutChart from "../../layout/Chart/DonutChart";

const TopCustomer = ({ sortDate }) => {
  const formatPrice = useFormatPrice();
  const [topCustomers, setTopCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  const selectNumberOfCstmr = 5;

  useEffect(() => {
    if (sortDate.fromDate && sortDate.toDate) {
      setLoading(true);
      API(controller.HomeReport + action.TopSellingCustomers).post(
        ToFormData({
          fromDate: new Date(sortDate.fromDate).toISOString(),
          toDate: new Date(sortDate.toDate).toISOString(),
          // Selecting number of customers
          number: selectNumberOfCstmr,
        }),
        (res) => {
          res && res.status === 200 && setTopCustomers([...res.result]);
          setLoading(false);
        }
      );
    }
    return () => {};
  }, [sortDate]);

  return !loading ? (
    <Paper className="shadow-xs p-[15px] bg-white">
      {/* Chart */}
      <DonutChart
        name={`Top ${selectNumberOfCstmr} Customers`}
        labels={[
          ...topCustomers.map((j) => {
            var name = j.customerName;
            name += ` | Qty: ${j.totalQuantitySold} | Amount: ${formatPrice(
              j.totalSalesAmount
            )}`;
            return name;
          }),
        ]}
        series={[...topCustomers.map((j) => j.totalQuantitySold)]}
      />
    </Paper>
  ) : (
    "Loading..."
  );
};

export default TopCustomer;
